import React from "react";
import ReactTable from "react-table";

class App extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <ReactTable
        data={this.props.data}
        filterable
        columns={this.props.columns}
        sortable={false}
        multiSort={false}
        resizable={false}
        filterable={false}
        showPageJump={true}
        defaultSortDesc={false}
        defaultSorted={[]}
        defaultFiltered={[]}
        defaultResized={[]}
        pageSize={this.props.pageSize}
        // page={this.props.sch_limit}
        // onChangePage={(pageIndex) => {
        //   this.setState({ tablePage: pageIndex });
        // }}
        // page={2}
        // PaginationComponent={this.Pagination1}
        // defaultPageSize={this.state.rowsPerPage}
        // showPagination={false}
        showPageSizeOptions={false}
        showPaginationTop={false}
        showPaginationBottom={false}
        className="-striped -highlight"
        previousText={<i className="fas fa-arrow-left"></i>}
        nextText={<i className="fas fa-arrow-right"></i>}
        loading={this.props.inLoading}
        // LoadingComponent={Loader}
        loadingText="Loading..."
        noDataText={"Data Not Found"}
        pageText={"Page"}
        ofText="/"
        rowsText={"Row"}
        className="-striped -highlight info-pagination"
      />
    );
  }
}

export default App;
